import { Component, ContentChild, Input } from '@angular/core';
import { WorkflowItemQueriesService } from '@workflow/queries/services/workflow-item-queries.service';
import { QueryState, WorkflowQueryDto } from '@interfaces/queries';
import { QueryEditActionsDirective } from '@workflow/queries/query-edit/query-edit-actions.directive';
import { QuestionSelectService } from '@workflow/queries/services/question-select.service';

function delay(milliseconds: number): Promise<void> {
	return new Promise<void>(resolve => setTimeout(resolve, milliseconds));
}

@Component({
	selector: 'workflow-query-edit',
	templateUrl: './query-edit.component.html',
	styleUrls: ['./query-edit.component.scss'],
})
export class QueryEditComponent {
	@Input()
	public queries: WorkflowQueryDto[] = [];
	
	public message: string | null = null;
	
	@ContentChild(QueryEditActionsDirective)
	public actions?: QueryEditActionsDirective;
	
	constructor(
		private readonly workflowItemQueriesService: WorkflowItemQueriesService,
		private readonly questionSelectService: QuestionSelectService,
	) {}
	
	public readonly comment = async (queryId: string, state?: QueryState): Promise<void> => {
		if (typeof this.message === 'string' || state !== undefined) {
			await this.workflowItemQueriesService.respond(queryId, {
				message: this.message,
				state,
			});
			
			this.message = null;
		}
	};
	
	public readonly onChange = async (item: WorkflowQueryDto | null): Promise<void> => {
		const key = item?.workflowKey;
		
		if (key) {
			const subscription = this.questionSelectService.highlight(key);
			
			await delay(1500);
			
			subscription.unsubscribe();
		}
	};
}
